import { ref, computed } from "vue";
import { defineStore } from "pinia";
import ApiService from "@/core/services/ApiService";
import { SystemInitDto, UserWithSimpleInfoDto } from "../core/services/ApiClient";
import { buildZoneTree } from "~/core/helpers/zoneTree";
import type { ZoneTreeDto } from "~/core/types/zone";

export const useSystemStore = defineStore("system", () => {
    const systemData = ref<SystemInitDto>();
    const users = ref<UserWithSimpleInfoDto[]>([]);
    const newsCount = ref<null>();
    const isInited = ref(false);

    const zones = computed<ZoneTreeDto[]>(() =>
        buildZoneTree(systemData.value?.category)
    );

    async function init() {
        const response = await ApiService.apiClient.initSystem()
        if (response.data) {
            isInited.value = true
            systemData.value = response.data;
            users.value = response.data.users || [];
        }
    }

    function reset() {
        isInited.value = false;
        systemData.value = undefined;
        users.value = [];
    }

    function newsGetCount() {
        ApiService.apiClient.newsGetCount().then((response) => {
            if (response.data) {
                newsCount.value = response.data;
            }
        });
    }

    return {
        isInited,
        systemData,
        users,
        zones,
        init,
        reset,
        newsCount,
        newsGetCount
    };
});
